/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Umkehren`
};

const en_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Invert`
};

const es_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Invertir`
};

const fr_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Inverser`
};

const it_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Inverti`
};

const nl_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Omkeren`
};

const pt_itinerary__invert = /** @type {(inputs: {}) => string} */ () => {
	return `Inverter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__invert(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__invert", locale)
	if (locale === "de") return de_itinerary__invert(inputs)
	if (locale === "en") return en_itinerary__invert(inputs)
	if (locale === "es") return es_itinerary__invert(inputs)
	if (locale === "fr") return fr_itinerary__invert(inputs)
	if (locale === "it") return it_itinerary__invert(inputs)
	if (locale === "nl") return nl_itinerary__invert(inputs)
	return pt_itinerary__invert(inputs)
};